// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ElevatorControl } from './elevator-control';


export class ElevatorControlMessage implements flatbuffers.IUnpackableObject<ElevatorControlMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):ElevatorControlMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsElevatorControlMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorControlMessage):ElevatorControlMessage {
  return (obj || new ElevatorControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsElevatorControlMessage(bb:flatbuffers.ByteBuffer, obj?:ElevatorControlMessage):ElevatorControlMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new ElevatorControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():ElevatorControl {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ElevatorControl.CarCallLock;
}

position():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

static startElevatorControlMessage(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addMessage(builder:flatbuffers.Builder, message:ElevatorControl) {
  builder.addFieldInt16(0, message, ElevatorControl.CarCallLock);
}

static addPosition(builder:flatbuffers.Builder, position:number) {
  builder.addFieldInt16(1, position, 0);
}

static endElevatorControlMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createElevatorControlMessage(builder:flatbuffers.Builder, message:ElevatorControl, position:number):flatbuffers.Offset {
  ElevatorControlMessage.startElevatorControlMessage(builder);
  ElevatorControlMessage.addMessage(builder, message);
  ElevatorControlMessage.addPosition(builder, position);
  return ElevatorControlMessage.endElevatorControlMessage(builder);
}

unpack(): ElevatorControlMessageT {
  return new ElevatorControlMessageT(
    this.message(),
    this.position()
  );
}


unpackTo(_o: ElevatorControlMessageT): void {
  _o.message = this.message();
  _o.position = this.position();
}
}

export class ElevatorControlMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: ElevatorControl = ElevatorControl.CarCallLock,
  public position: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return ElevatorControlMessage.createElevatorControlMessage(builder,
    this.message,
    this.position
  );
}
}
